import styled from "@emotion/styled"
import { useSessionStorage } from "@mantine/hooks"
import { FaTimes } from "@react-icons/all-files/fa/FaTimes"
import { TbChevronRight } from "@react-icons/all-files/tb/TbChevronRight"
import { Value, htmlFormatTags } from "@stringtale/react"
import Image from "next/image"
import { PX14 } from "theme/sizes"
import Button from "ui/Button"
import ContainerBase from "ui/Container"
import Group from "ui/Group"
import Link from "ui/Link"
import { GetMaintenanceResult } from "../queries/getMaintenance"
import { FormatValue } from "./FormatValue"

const Root = styled.div<{
  backgroundColor?: string | null
  textColor?: string | null
}>`
  background-color: ${(p) =>
    p.backgroundColor ? p.backgroundColor : "#e0673c"};
  color: ${(p) => (p.textColor ? p.textColor : "#ffffff")};
  font-size: ${PX14};
`

const Container = styled(ContainerBase)`
  margin: 10px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`

export default function MaintenanceBar({
  props,
}: {
  props?: GetMaintenanceResult
}) {
  const [isHidden, setHidden] = useSessionStorage({
    key: "maintenance",
    defaultValue: "false",
  })
  if (!props?.maintenanceMessage || isHidden === "true") {
    return null
  }
  return (
    <Root
      backgroundColor={props?.maintenanceColor}
      textColor={props?.maintenanceTextColor}
    >
      <Container>
        <Group gap="8px" justify="flex-start">
          <Image src="/icons/ico_megph_wh.svg" width={24} height={24} alt="" />
          <div>
            {props.maintenanceMessage === "true" ? (
              <Value
                name="apps.web.src.core.components.maintenancebar.maintenance"
                format={htmlFormatTags}
                version="1"
              >
                {`<b>
                Technisch onderhoud maandag 29 april.</b>
                Tussen 10.00-16.00 uur kan 123ZING tijdelijk niet bereikbaar zijn.`}
              </Value>
            ) : (
              <Group wrap={false}>
                <FormatValue format={htmlFormatTags}>
                  {props.maintenanceMessage}
                </FormatValue>
                {props.maintenanceLink && props.maintenanceLinkText && (
                  <>
                    &nbsp;
                    <Link
                      href={props.maintenanceLink}
                      target="_blank"
                      bold
                      underline
                    >
                      <Group wrap={false} align="center">
                        {props.maintenanceLinkText}
                        <TbChevronRight size={16} />
                      </Group>
                    </Link>
                  </>
                )}
              </Group>
            )}
          </div>
        </Group>
        <Button onClick={() => setHidden("true")}>
          <FaTimes size={16} />
        </Button>
      </Container>
    </Root>
  )
}
